// --------------------------------------------------------------------
// @author: shiraho@syg.com(必填, 创建模块的人员)
// @description:
//      所有非组件类的基类
// <br/>Create: new Date().toISOString()
// --------------------------------------------------------------------
window.BaseClass = cc.Class({
    ctor:function(){

    },
    
})
